module.exports = __webpack_public_path__ + "b13d1440e1d8f4c55361656fd3191952.svg";